<template>
  <div ref="captchaAvgSolverGraph" class="captcha-active-solver-graph">
    <div class="captcha-active-solver-graph-column">
      <div class="captcha-active-solver-header">
        <div>
          <h1>Partner Earnings</h1>
          <p>An overview of your earnings from your partners</p>
        </div>
        <div>
          <p @click="refresh" style="cursor: pointer">REFRESH</p>
        </div>
      </div>
      <div class="captcha-actual-graph">
        <div v-if="graphData.length > 0" style="height: 100%">
          <GraphExample :graphData="graphData"></GraphExample>
        </div>
        <div v-if="graphData.length == 0" style="height: 100%">
          <GraphExample :graphData="graphData"></GraphExample>
        </div>
      </div>
      <div class="captcha-footer">
        <div class="captcha-footer-left">
          <div class="captcha-footer-item">
            <p>Start date</p>
            <DatePicker
              color="yellow"
              v-model="startDate"
              is-dark
              :popover="{ placement: 'bottom', visibility: 'click' }"
            >
              <div class="captcha-date-range">
                {{ startDate }}
              </div>
            </DatePicker>
          </div>
          <div class="captcha-footer-item">
            <p>End date</p>
            <DatePicker
              color="yellow"
              v-model="endDate"
              is-dark
              :popover="{ placement: 'bottom', visibility: 'click' }"
            >
              <div class="captcha-date-range">
                {{ endDate }}
              </div>
            </DatePicker>
          </div>
        </div>
        <div class="captcha-footer-right"></div>
      </div>
    </div>
  </div>
</template>

<script>
import GraphExample from "../../../views/GraphExample";

import DatePicker from "v-calendar/lib/components/date-picker.umd";
import { handleGetPartnerChart } from "../../../service/partner";
import moment from "moment";

export default {
  components: {
    GraphExample,
    DatePicker,
  },
  data() {
    return {
      startDate: new Date(),
      endDate: new Date(),
      graphData: [],
    };
  },

  watch: {
    startDate: function() {
      this.updateData();
    },
    endDate: function() {
      this.updateData();
    },
  },

  async mounted() {
    this.startDate = moment(this.startDate)
      .subtract(1, "months")
      .format("L");
    this.endDate = moment(this.endDate).add(1, 'day').format("L");

    await this.sleep(80);
    this.$refs.captchaAvgSolverGraph.style = "transform: scale(1) !important";

    const response = await handleGetPartnerChart(this.startDate, this.endDate);
    this.graphData = response.data.data.results;
  },
  methods: {
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async updateData() {
      this.startDate = moment(this.startDate).format("L");
      this.endDate = moment(this.endDate).format("L");
      this.graphData = [];
      const referralData = await handleGetPartnerChart(
        this.startDate,
        this.endDate
      );
      this.graphData = referralData.data.data.results;
    },

    switchFilter(e) {
      this.sType = e;
      this.refresh();
    },

    refresh() {
      this.updateData();
    },
  },
};
</script>

<style scoped>
.captcha-active-solver-graph {
  /* margin-top: 30px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: auto;
  max-width: 100%;
  width: 100%;
  background: radial-gradient(
    100% 100% at 44.04% 0%,
    #26292e85 0%,
    #1a1c1f 100%
  );
  mix-blend-mode: normal;
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.0835883), inset 0px 1px 3px #000000;
  border-radius: 7px;
  transform: scale(0.5);
  transition: 0.4s;
  z-index: 5;
}
.captcha-active-solver-graph-column {
  margin: 15px;
  height: 95%;
  width: 95%;
}
.captcha-date-range {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "OpenSans-Bold";
  color: #eddb51;
}

.captcha-active-solver-header {
  display: flex;
  justify-content: space-between;
}

.captcha-active-solver-header > div:nth-of-type(odd) {
  display: flex;
  flex-direction: column;
}
.captcha-active-solver-header > div:nth-of-type(odd) > h1 {
  color: #e0e0e0;
  font-size: 20px;
  font-family: "OpenSans";
}
.captcha-active-solver-header > div:nth-of-type(odd) > p {
  color: #888888;
  font-size: 12px;
}
.captcha-active-solver-header > div:nth-of-type(even) > p {
  color: #888888;
  font-size: 10px;
}
.captcha-actual-graph {
  background-color: #131517;
  height: 313px;
  margin-top: 25px;
  border-radius: 10px;
}

.captcha-footer {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.captcha-footer-left {
  flex: 45%;
  display: flex;
  align-items: center;
}
.captcha-footer-right {
  flex: 45%;
  display: flex;
  justify-content: flex-end;
}

.captcha-footer-right > .captcha-footer-item > .captcha-date-range {
  width: 40% !important;
}

.captcha-footer:nth-of-type(odd) {
  display: flex;
}
.captcha-footer:nth-of-type(even) {
  display: flex;
}

.captcha-footer-item {
  display: flex;
  flex-direction: column;
  width: 44%;
  margin-top: 12px;
}
.captcha-footer-item > p {
  margin-left: 10px;
  color: #888888;
  font-family: "OpenSans";
}
.captcha-date-range {
  height: 45px;
  width: 70%;
  background-color: #131517;
  border-radius: 10px;
  margin-top: 10px;
  background: #131517;
  box-shadow: 0px 2px 4px #000000, inset 0px 1px 3px #000000;
  border-radius: 5px;
}
.captcha-footer-right > .captcha-footer-item {
  width: 44% !important;
}
.captcha-footer-item-2 {
  align-items: flex-end;
}

@media only screen and (max-width: 710px) {
  .captcha-footer-left {
    flex: 65% !important;
    width: 65% !important;
    max-width: 65% !important;
    align-items: stretch;
    justify-content: space-around;
  }
  .captcha-footer-right {
    flex: 35% !important;
    width: 35% !important;
    max-width: 35% !important;
  }
  .captcha-footer-right > .captcha-footer-item > .captcha-date-range {
    width: 100% !important;
  }
  .captcha-date-range {
    width: 100% !important;
  }

  .captcha-footer {
    flex-wrap: wrap;
  }

  .captcha-footer-right {
    flex: 100% !important;
    max-width: 100% !important;
    justify-content: flex-start;
  }
  .captcha-footer-left {
    flex: 100% !important;
    max-width: 100% !important;
  }
}
</style>
